export interface HttpDto<T> {
  readonly data: T
}

export class HttpDelete implements HttpDto<{ ok: boolean }> {
  readonly data: { ok: boolean }
}
